module.exports = __webpack_public_path__ + "static/pymnts-banner-35aa151845eb706997d4337d1d298e6b.png";